import {
  CREATE_PRICE_FAILURE,
  CREATE_PRICE_REQUEST,
  GET_ALL_PRICE_REQUEST,
  GET_ALL_PRICE_SUCCESS,
  GET_ALL_PRICE_FAILURE,
  DELETE_PRICE_REQUEST,
  DELETE_PRICE_FAILURE,
  UPDATE_PRICE_REQUEST,
  UPDATE_PRICE_FAILURE,
} from "./ActionType";

const initialState = {
  prices: [],
  loading: false,
  error: "",
};

export const vendorProductPriceHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRICE_REQUEST:
      return { ...state, loading: true };

    case CREATE_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_PRICE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PRICE_SUCCESS:
      return { ...state, loading: false, error: "", prices: action.payload };

    case GET_ALL_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PRICE_REQUEST:
      return { ...state, loading: true };

    case DELETE_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PRICE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
